<template>
  <div class="i-chart-warpper">
    <div class="unconnected" v-if="!needRefresh">
      <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-alert-circle"></use>
      </svg>
      Offline
    </div>
    <span>
      <svg class="icon" aria-hidden="true" style="font-size:112px;margin-right: -5px;color:#409EFF;">
        <use xlink:href="#icon-si-glyph-antenna-"></use>
      </svg>
      <svg class="icon" aria-hidden="true" style="font-size:128px;" :style="{fill: rateColor}">
        <use :xlink:href="rateIcon"></use>
      </svg>
    </span>
    <p class="imt-2 headline">
      <!-- {{datas[propName]}} -->
      <span class="description">{{rateText}}</span>
    </p>
  </div>
</template>

<script>
import { ERR_DATA } from './config'
export default {
  props: {
    datas: {
      type: Object,
      default: () => ({})
    },
    propName: {
      type: String,
      default: 'cellidSignal'
    }
  },
  watch: {
    datas() {
      this.rate = this.datas[this.propName]
    }
  },
  data() {
    return {
      rate: this.datas[this.propName]
    }
  },
  computed: {
    needRefresh() {
      return this.datas.Status != 0
    },
    rateText() {
      const n = parseInt(this.rate)
      if (n < 8) {
        return 'no signal'
      } else if (n < 16) {
        return 'weak'
      } else if (n < 24) {
        return 'good'
      } else {
        return 'strong'
      }
    },
    rateIcon() {
      const n = parseInt(this.rate)
      let icon = 0
      if (n < 4) {
        icon = 0
      } else if (n < 8) {
        icon = 1
      } else if (n < 16) {
        icon = 2
      } else if (n < 24) {
        icon = 3
      } else {
        icon = 4
      }

      return `#icon-icon-i-signal-${icon}`
    },
    rateColor() {
      let color = '#4CAF50'
      const n = parseInt(this.rate)
      if (n < 4) {
        color = '#FF5722'
      } else if (n < 16) {
        color = '#FF9800'
      } else if (n < 25) {
        color = '#FFEB3B'
      } else {
        color = '#4CAF50'
      }
      return color
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.i-chart-warpper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  .unconnected {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(96,125,139,.4);
    text-align: center;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #FFF;
  }
  .description {
    //margin-left: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/charts/chart-signal.vue